import {
  AccordionDemo,
  AudioDemo,
  BarChartDemo,
  ButtonDemo,
  CardItemsDemo,
  CircleProgressDemo,
  DatatableDemo,
  FABDemo,
  ImageDemo,
  ListDemo,
  LocationDemo,
  PieChartDemo,
  RatingProgressDemo,
  VideoDemo,
} from '.'

export const CarouselDemo = () => {
  const components = [
    <ImageDemo key='1' />,
    <BarChartDemo key='2' />,
    <PieChartDemo key='3' />,
    <CardItemsDemo key='4' />,
    <DatatableDemo key='5' />,
    <ListDemo key='6' />,
    <AudioDemo key='7' />,
    <VideoDemo key='8' />,
    <ButtonDemo key='9' />,
    <FABDemo key='10' />,
    <RatingProgressDemo key='11' />,
    <CircleProgressDemo key='12' />,
    <LocationDemo key='13' />,
    <AccordionDemo key='14' />,
  ]

  return (
    <>
      {/* <div className='block md:hidden overflow-hidden'>
        <div className='grid grid-flow-col gap-4 animate-marquee-mobile' style={{ gridAutoColumns: '100%' }}>
          {[...components, ...components].map((component, index) => (
            <div key={index} className='grid items-stretch px-4'>
              {component}
            </div>
          ))}
        </div>
      </div> */}

      {/* <div className='hidden md:block overflow-hidden'>
        <div className='grid grid-flow-col gap-4 animate-marquee-desktop' style={{ gridAutoColumns: 'calc(100% / 4)' }}>
          {[...components, ...components].map((component, index) => (
            <div key={index} className='grid items-stretch px-2'>
              {component}
            </div>
          ))}
        </div>
      </div> */}
    </>
  )
}
